// Канонические footer-props для v-data-table — глобальный mixin
// (main.js: Vue.mixin), по образцу setErrorMixin/roleMixin.
//
// Зачем: объект footer-props был скопирован ~80 раз по ~30 компонентам, и все
// копии показывали на телефоне четыре стрелки (showFirstLastPage) плюс длинную
// подпись «Элементов на странице:» — футер не влезал и разваливался на две
// кривые строки. Чинить это в 80 местах условиями по месту — значит развести
// 80 новых вариантов.
//
// Мобильность считается по $vuetify.breakpoint.smAndDown (<960px) — это то же
// понятие, что компонентный isMobile (checkMobile: xs || sm), только без
// обязанности заводить v-resize в каждом компоненте. Breakpoint реактивен,
// футер перестраивается при повороте/ресайзе сам.
//
// На мобильном: без кнопок |< >| (остаются две стрелки) и без подписи у
// селектора количества строк. Desktop-вид не меняется.
//
// pageText по умолчанию — диапазон страницы из общего числа: Vuetify подставляет
// {0} — первый, {1} — последний элемент страницы, {2} — всего. Прежнее «{0} из {1}»
// выводило «1 из 20» на 23 строках. Вторым аргументом pageText передаётся там, где
// он нестандартный: серверный total (`{0} из ${total}` — Bookings, Clients, Fines и др.).
export default {
  methods: {
    tableFooterProps(itemsPerPageOptions = [20, 50, 100, -1], pageText = null) {
      const mobile = this.$vuetify.breakpoint.smAndDown;
      return {
        pageText: pageText || `{0}-{1} ${this.$t("custom.of")} {2}`,
        itemsPerPageText: mobile ? "" : this.$t("custom.elements_table"),
        showFirstLastPage: !mobile,
        itemsPerPageOptions,
      };
    },
  },
};
